const zh = {
  "app.tagline": "高端网络游戏交易平台",
  "nav.marketplace": "商城",
  "nav.orders": "订单",
  "nav.dashboard": "控制台",
  "nav.chat": "消息",
  "nav.login": "登录",
  "nav.register": "注册",
  "nav.logout": "退出",
  "nav.account": "账户",
  "landing.hero.title": "值得信赖的网络游戏交易",
  "landing.hero.sub": "MQL Group 提供游戏币、账号、道具和代练服务。交易安全，发货迅速。",
  "landing.cta.browse": "浏览商品",
  "landing.cta.register": "立即注册",
  "landing.f1.title": "安全交易",
  "landing.f1.desc": "付款由 MQL Group 团队核实",
  "landing.f2.title": "快速发货",
  "landing.f2.desc": "平均 30 分钟内发货",
  "landing.f3.title": "认证供应商",
  "landing.f3.desc": "库存仅来自通过 KYC 认证的供应商",
  "landing.f4.title": "尊享服务",
  "landing.f4.desc": "专业客服 24/7 在线聊天支持",
  "auth.email": "邮箱",
  "auth.password": "密码",
  "auth.name": "姓名",
  "auth.role": "注册身份",
  "auth.role.buyer": "买家",
  "auth.role.supplier": "供应商",
  "auth.login": "登录",
  "auth.register": "注册",
  "auth.have_account": "已有账户？",
  "auth.no_account": "还没有账户？",
  "auth.forgot": "忘记密码？",
  "auth.welcome_back": "欢迎回来",
  "auth.welcome": "欢迎",
  "auth.login_failed": "登录失败",
  "auth.register_failed": "注册失败",
  "auth.accept_prefix": "我已阅读并同意",
  "auth.policy.buyer": "买家政策",
  "auth.policy.supplier": "供应商政策",
  "kyc.notice": "供应商必须完成 KYC 认证。管理员审核通过身份证后账户方可使用。照片仅店主和员工可见。",
  "kyc.telegram": "Telegram 用户名",
  "kyc.whatsapp": "WhatsApp 号码",
  "kyc.contact_hint": "请至少填写一项：Telegram 或 WhatsApp，方便管理员联系您。",
  "kyc.ktp": "身份证（KTP）照片",
  "kyc.ktp_hint": "身份证完整清晰，不模糊。",
  "kyc.selfie": "手持身份证自拍",
  "kyc.selfie_hint": "面部和身份证在同一张照片中清晰可见。",
  "kyc.sent_title": "注册已提交",
  "kyc.sent_body": "管理员正在审核您的 KYC 资料。审核通过后您将收到邮件，然后即可登录。",
  "market.search": "搜索商品...",
  "market.all_games": "全部游戏",
  "market.all_categories": "全部分类",
  "market.in_stock": "仅显示有货",
  "market.buy": "购买",
  "market.detail": "详情",
  "market.stock": "库存",
  "market.all_servers": "全部服务器",
  "market.all_regions": "全部地区",
  "market.all_factions": "全部阵营",
  "market.min_price": "最低价 (IDR)",
  "market.max_price": "最高价 (IDR)",
  "market.apply": "应用",
  "market.reset": "重置",
  "market.err_minmax": "最低价高于最高价",
  "market.load_failed": "商品加载失败",
  "product.description": "描述",
  "product.add_to_order": "立即下单",
  "product.quantity": "数量",
  "product.stock_after": "购买后剩余库存",
  "product.qty_decrease": "减少数量",
  "product.qty_increase": "增加数量",
  "product.qty_max": "最大",
  "product.not_found": "未找到商品",
  "product.not_found_sub": "该商品已下架或已删除。",
  "product.back": "返回商城",
  "product.login_first": "请先登录",
  "product.buyers_only": "只有买家可以下单",
  "product.invalid_qty": "数量无效",
  "product.order_created": "订单已创建",
  "product.order_failed": "创建订单失败",
  "checkout.title": "订单信息",
  "checkout.sub": "请选择交付方式，并在确认前核对订单摘要。",
  "checkout.payment_method": "支付方式",
  "checkout.notes": "交付备注",
  "checkout.total": "合计",
  "checkout.method": "交付方式",
  "checkout.character": "角色名",
  "checkout.account_id": "账号 ID / 用户 ID",
  "checkout.auction_notes": "挂单详情（物品、价格、时间）",
  "checkout.product": "商品",
  "checkout.game_server": "游戏 / 服务器",
  "checkout.qty": "数量",
  "checkout.unit_price": "单价",
  "checkout.fee": "附加费用",
  "checkout.payment": "支付",
  "checkout.grand_total": "订单总额",
  "checkout.use_balance": "使用商城余额",
  "checkout.balance_available": "可用",
  "checkout.balance_used": "商城余额支付",
  "checkout.amount_due": "应付金额",
  "checkout.usd_note": "此方式以美元支付，汇率在订单创建时锁定。",
  "checkout.confirm": "确认订单",
  "checkout.processing": "处理中...",
  "delivery.mail": "邮件",
  "delivery.mail.desc": "物品通过游戏内邮件发送给您的角色。",
  "delivery.trade": "交易 / 当面交付",
  "delivery.trade.desc": "MQL 员工在游戏内与您的角色见面并进行交易。",
  "delivery.auction": "拍卖行",
  "delivery.auction.desc": "您在拍卖行挂出一件低价物品，MQL 员工按订单金额购买。",
  "delivery.topup": "直接充值",
  "delivery.topup.desc": "余额直接充入您的游戏账号/ID。",
  "delivery.service": "MQL 团队服务",
  "delivery.service.desc": "代练/升级/任务由 MQL 团队完成。付款核实后，通过消息安全沟通登录信息和时间安排。请勿在备注中填写密码。",
  "delivery.account_handover": "账号交接",
  "delivery.account_handover.desc": "付款核实后，员工将通过消息发送账号登录信息。",
  "order.status.waiting_payment": "等待付款",
  "order.status.verifying": "核实付款中",
  "order.status.preparing": "准备中",
  "order.status.shipped": "已发货",
  "order.status.completed": "已完成",
  "order.status.cancelled": "已取消",
  "order.status.resolution": "纠纷处理",
  "order.status.trade_ready": "员工已准备交易",
  "order.status.partial_delivery": "分批交付",
  "order.upload_proof": "上传付款凭证",
  "order.my_orders": "我的订单",
  "order.all": "全部",
  "order.no": "订单号",
  "order.date": "日期",
  "order.items": "商品",
  "order.status": "状态",
  "order.detail": "详情",
  "order.back": "← 返回",
  "order.payment_proof": "付款凭证",
  "order.history": "状态记录",
  "order.payment": "支付",
  "order.delivery": "交付",
  "order.character": "角色 / ID",
  "order.send": "发送",
  "order.proof_sent": "付款凭证已发送",
  "order.upload_failed": "上传失败",
  "order.max_5mb": "最大 5MB",
  "order.trade_ready_badge": "可交易",
  "order.trade_ready_title": "员工现在已准备好交易",
  "order.trade_ready_char": "请使用以下角色上线：",
  "order.shipped_title": "物品已发货",
  "order.progress": "交付进度",
  "order.delivered": "已交付",
  "order.refund": "已退回商城余额",
  "order.balance_used": "商城余额支付",
  "order.amount_due": "应付金额",
  "order.unique_code": "唯一码",
  "order.pay_within": "请在倒计时结束前付款，否则订单将自动取消",
  "order.pay_expired": "付款时间已到 — 订单正在取消",
  "product.min_order": "最低购买金额",
  "product.min_order_err": "该商品最低购买金额为 {amount}",
  "order.transfer_exact": "请转账上方的准确金额（含唯一码 +{code}），以便快速识别付款。",
  "order.scan_qris": "使用任意银行 / 电子钱包应用扫描，金额自动填写。",
  "order.scan_usdt": "使用加密钱包扫描以复制地址。",
  "order.usdt_warning": "仅通过 TRON (TRC20) 网络发送 USDT，其他网络将导致资产丢失。",
  "order.usdt_network_warning": "仅通过 {network} 网络发送 USDT，其他网络的转账可能丢失。",
  "order.usdt_locked": "锁定汇率：1 USDT = {rate} · 总计 {total}",
  "order.binance_scan": "使用 Binance 应用 (Pay) 扫码，或转账至下方 UID",
  "order.binance_name": "账户名称",
  "order.binance_exact": "请按上方 USDT 金额准确支付，然后上传付款凭证。",
  "checkout.usdt_note": "按最新汇率自动换算，向上取整至 2 位小数。下单时锁定汇率。1 USDT = {rate}",
  "checkout.fx_changed": "汇率刚刚更新，请查看新的 USDT 金额后再次确认。",
  "order.rate": "汇率",
  "notif.title": "通知",
  "notif.empty": "暂无通知",
  "balance.title": "商城余额",
  "balance.desc": "已取消订单中未交付部分的退款。可用于在 MQL 的下次购物，不可提现。",
  "balance.history": "余额记录",
  "balance.refund": "退款",
  "balance.payment": "支付",
  "footer.contact": "MQL Store — 联系信息",
  "footer.phone": "电话",
  "policy.buyer": "买家政策",
  "policy.supplier": "供应商政策",
  "policy.updated": "版本",
  "policy.lang_note": "供应商政策提供英文和印尼文版本。",
  "common.loading": "加载中...",
  "common.empty": "暂无数据",
  "common.save": "保存",
  "acct.label": "账户",
  "acct.title": "账户设置",
  "acct.profile": "个人资料",
  "acct.role": "角色",
  "role.owner": "店主",
  "role.staff": "员工",
  "role.supplier": "供应商",
  "role.buyer": "买家",
  "acct.change_pw": "修改密码",
  "acct.current_pw": "当前密码",
  "acct.new_pw": "新密码（至少 8 个字符）",
  "acct.confirm_pw": "再次输入新密码",
  "acct.save_pw": "保存新密码",
  "acct.saving": "保存中...",
  "acct.pw_mismatch": "两次输入的密码不一致",
  "acct.pw_changed": "密码已修改，其他设备上的登录已自动退出。",
  "twofa.codes_copied": "恢复码已复制",
  "twofa.codes_note": "请将这些恢复码保存在安全的地方。手机丢失时每个恢复码只能使用一次，之后不会再显示。",
  "twofa.copy": "复制",
  "twofa.saved": "我已保存",
  "twofa.enable_start": "启用 Google Authenticator",
  "twofa.step1": "1. 使用 Google Authenticator 应用扫描此二维码。",
  "twofa.manual": "无法扫描？请手动输入此密钥：",
  "twofa.step2": "2. 输入应用中显示的 6 位验证码。",
  "twofa.verify": "验证并启用",
  "twofa.code_label": "验证器代码",
  "twofa.regen": "生成新的恢复码",
  "twofa.mandatory_note": "店主/员工账户必须启用 2FA，且无法关闭。员工手机丢失时，店主可在 管理 → 员工账户 中重置 2FA。",
  "twofa.disable": "关闭 2FA",
  "twofa.disabled": "2FA 已关闭",
  "twofa.on": "2FA 已启用 — 登录需要验证器代码。",
  "twofa.required": "您的账户必须启用 2FA。请立即启用以解锁菜单。",
  "twofa.off": "2FA 未启用。",
  "twofa.enabled": "2FA 已启用",
  "sound.title": "通知提示音",
  "sound.order": "订单提示音",
  "sound.message": "消息提示音",
  "sound.volume": "音量",
  "sound.off": "关闭",
  "sound.chime": "风铃",
  "sound.bell": "铃声",
  "sound.coin": "金币",
  "sound.ping": "叮",
  "sound.test": "试听",
  "sound.saved": "提示音设置已保存",
  "sound.custom_group": "商城提示音",
  "sound.autoplay_note": "网站打开时，在您点击页面后才会播放提示音（浏览器规则）。",
  "order.watch_video": "观看发货凭证视频",
  "order.chat_staff": "联系客服",
  "maint.title": "系统维护中",
  "maint.countdown": "计划维护将在以下时间后开始",
  "maint.sub": "我们正在升级 MQL Group。您的账户、订单和商城余额都是安全的。",
  "order.refund_title": "{amount} 已退回您的商城余额",
  "order.refund_body": "您的资金是安全的。这是本订单未交付部分的退款，可立即用于下次购物。",
  "order.chat_failed": "无法打开聊天",
};

export default zh;
